import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

// Connects to data-controller="search"
export default class extends Controller {
	static targets = ["query"]

	connect() {
		this.modal = new Modal(this.element)
		this.modal.show()
		this.element.addEventListener('shown.bs.modal', () => {
			this.queryTarget.focus()
		})
	}

	disconnect() {
		this.modal.hide()
	}
}